<template>
  <div class="gkmg-pm-dialog-port-vessel">
    <vs-row vs-w="12" style="height: 5rem">
      <vs-col class="w-full">
        <vs-row style="height: 50%">
          <vs-col vs-w="12" class="flex items-center">
            <div class="th">
              <span>船舶名</span>
            </div>
            <div class="td">
              <div class="vessel-name-area">
                <div
                  class="vessel-name-show-area flex items-center h-full"
                  v-if="!isEditVesselName"
                >
                  <span
                    style="
                      font-weight: bolder;
                      font-size: larger;
                      margin-right: 1rem;
                    "
                    >{{ taskVesselName }}</span
                  >
                  <!-- 船舶名編集モードに移行するボタン 編集可能な時だけ表示 -->
                  <button
                    v-if="canEdit"
                    class="edit-vessel-name inline-flex justify-center items-center outline-none border-none m-0 w-fit"
                    type="button"
                    @click="onClickEditVesselName"
                  >
                    <feather-icon icon="Edit2Icon" svgClasses="h-5 w-5" />
                  </button>
                </div>
                <!-- 船舶名編集エリア -->
                <div
                  class="vessel-name-input-area h-full flex items-center gap-2 flex-wrap"
                  v-else
                >
                  <vs-input
                    v-show="isTextMode"
                    class="input-task-vessel-name"
                    v-model="tmpVesselName"
                    :danger="!isValidVesselName"
                    placeholder="船舶名を入力してください"
                    @keyup.enter="onClickUpdateVessel"
                    @keyup.esc="cancelEditVesselName"
                    color="#626262"
                  />
                  <v-select
                    v-show="!isTextMode"
                    class="display-items-select-box flex-grow"
                    v-model="selectedVessel"
                    :options="vesselOptions"
                    label="label"
                    placeholder="選択してください"
                    :clearable="false"
                    :searchable="false"
                  >
                    <template #selected-option="{}">
                      <div style="display: flex; align-items: baseline">
                        {{ selectedVesselName }}
                      </div>
                    </template>
                    <template v-slot:no-options>
                      <div>選択可能な船舶がありません</div>
                    </template>
                  </v-select>
                  <button
                    class="edit-vessel-name select-input-mode inline-flex justify-center items-center outline-none border-none m-0 w-fit"
                    :class="{ 'selected-mode': !isTextMode }"
                    type="button"
                    @click="moveToSelectMode"
                  >
                    <feather-icon icon="SearchIcon" svgClasses="h-5 w-5" />
                  </button>
                  <button
                    class="edit-vessel-name select-input-mode inline-flex justify-center items-center outline-none border-none m-0 w-fit"
                    :class="{ 'selected-mode': isTextMode }"
                    type="button"
                    @click="moveToTextMode"
                  >
                    <feather-icon icon="PenToolIcon" svgClasses="h-5 w-5" />
                  </button>
                  <button
                    class="edit-vessel-name update-vessel-name inline-flex justify-center items-center outline-none border-none m-0 ml-3 w-fit"
                    type="button"
                    @click="onClickUpdateVessel"
                    :disabled="!isValidVesselInfo"
                  >
                    <feather-icon icon="CheckCircleIcon" svgClasses="h-5 w-5" />
                  </button>
                  <button
                    class="edit-vessel-name cancel-edit-vessel-name inline-flex justify-center items-center outline-none border-none m-0 w-fit"
                    type="button"
                    @click="cancelEditVesselName"
                  >
                    <feather-icon icon="XCircleIcon" svgClasses="h-5 w-5" />
                  </button>
                </div>
              </div>
            </div>
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>
    <template v-if="isSameTaskVesselNameAndMasterVesselName">
      <hr />
      <vs-row vs-w="12" style="height: 5rem">
        <vs-col class="w-full">
          <vs-row style="height: 50%">
            <vs-col class="flex items-center th">
              <div class="th">注意</div>
              <div class="td">
                <!-- 仕様上「注意」項目は表示するが、その内容はハイフンを表示することとなっている -->
                <span> - </span>
              </div>
            </vs-col>
          </vs-row>
          <vs-row style="height: 50%">
            <vs-col class="flex items-center th">
              <div class="th">備考</div>
              <div class="td">
                <span>{{ vesselsMaster.data.required_note || "-" }}</span>
              </div>
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>
      <hr style="margin: 1rem 0" />
      <vs-row vs-w="12">
        <vs-col
          vs-w="6"
          vs-justify="flex-start"
          vs-align="flex-start"
          id="pm-vessel-live-map-container-area"
          class="vs-con-loading__container"
        >
          <div id="pm-vessel-live-map-container"></div>
        </vs-col>
        <vs-col
          vs-w="6"
          vs-justify="flex-start"
          vs-align="flex-start"
          style="padding: 0.4rem"
        >
          <vs-row vs-w="12" class="pm-port-vessel-detail">
            <vs-col vs-w="4" class="flex items-center">
              <span class="th" style="padding-left: 1rem"> 船種 </span>
            </vs-col>
            <vs-col vs-w="8" class="flex items-center">
              <span class="td">{{
                (vesselsMaster &&
                  vesselsMaster.data &&
                  vesselsMaster.data.type) ||
                "-"
              }}</span>
            </vs-col>
          </vs-row>
          <vs-row vs-w="12" class="pm-port-vessel-detail">
            <vs-col vs-w="4" class="flex items-center">
              <span class="th" style="padding-left: 1rem"> 載貨重量 </span>
            </vs-col>
            <vs-col vs-w="8" class="flex items-center">
              <div class="td pm-lat-long">
                <span>{{
                  (vesselsMaster &&
                    vesselsMaster.data &&
                    vesselsMaster.data.loading_weight) ||
                  "-"
                }}</span>
              </div>
            </vs-col>
          </vs-row>
          <vs-row vs-w="12" class="pm-port-vessel-detail">
            <vs-col vs-w="4" class="flex items-center">
              <span class="th" style="padding-left: 1rem"> 乗船台数 </span>
            </vs-col>
            <vs-col vs-w="8" class="flex items-center">
              <span class="td">{{
                (vesselsMaster &&
                  vesselsMaster.data &&
                  vesselsMaster.data.boarding_number) ||
                "-"
              }}</span>
            </vs-col>
          </vs-row>
          <vs-row vs-w="12" class="pm-port-vessel-detail">
            <vs-col vs-w="4" class="flex items-center">
              <span class="th" style="padding-left: 1rem"> 調達会社名 </span>
            </vs-col>
            <vs-col vs-w="8" class="flex items-center">
              <span class="td">{{
                (vesselsMaster &&
                  vesselsMaster.data &&
                  vesselsMaster.data.company_name) ||
                "-"
              }}</span>
            </vs-col>
          </vs-row>
          <vs-row vs-w="12" class="pm-port-vessel-detail">
            <vs-col vs-w="4" class="flex items-center">
              <span class="th" style="padding-left: 1rem"> 必要車両数 </span>
            </vs-col>
            <vs-col vs-w="8" class="flex items-center">
              <span class="td">{{
                (vesselsMaster &&
                  vesselsMaster.data &&
                  vesselsMaster.data.default_vehicles_count) ||
                "-"
              }}</span>
            </vs-col>
          </vs-row>
          <vs-row vs-w="12" class="pm-port-vessel-detail">
            <vs-col vs-w="4" class="flex items-center">
              <span class="th" style="padding-left: 1rem"> 出航必要人数 </span>
            </vs-col>
            <vs-col vs-w="8" class="flex items-center">
              <span class="td">{{
                (vesselsMaster &&
                  vesselsMaster.data &&
                  vesselsMaster.data.departure_head_count) ||
                "-"
              }}</span>
            </vs-col>
          </vs-row>
          <vs-row vs-w="12" class="pm-port-vessel-detail">
            <vs-col vs-w="4" class="flex items-center">
              <span class="th" style="padding-left: 1rem"> 入港必要人数 </span>
            </vs-col>
            <vs-col vs-w="8" class="flex items-center">
              <span class="td">{{
                (vesselsMaster &&
                  vesselsMaster.data &&
                  vesselsMaster.data.entry_head_count) ||
                "-"
              }}</span>
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>

      <component :is="'style'" v-if="loading === false && !isFindVessel">
        #pm-vessel-live-map-container::after{ content:
        '船舶が見つかりませんでした'; font-size: 130%; color:white;
        background-color: #09151c; opacity: 0.8; z-index: 999; text-align:
        center; vertical-align: text-bottom; line-height: 18rem; position:
        absolute; top: 0; right: 0; bottom: 0; left: 0; display:block }
      </component>
    </template>
  </div>
</template>

<script>
import { createNamespacedHelpers, mapGetters } from "vuex";
const { mapActions: mapActionsOfVesselView } = createNamespacedHelpers(
  "enterpriseVesselView",
);
const { mapGetters: mapGettersOfGkmgPortMaster } =
  createNamespacedHelpers("gkmgPortMaster");

const {
  mapActions,
  mapGetters: mapGettersOfGkmgPortMasterDestinationWork,
  mapState,
} = createNamespacedHelpers("gkmgPortMasterDestinationWork");
import Mapbox from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import { MAP_STYLE_DEFAULT } from "@/config/const";
import { LiveVesselMapLayer, LiveVesselMapSource } from "@/config/Map.js";
import moment from "moment-timezone";
import isObject from "lodash/isObject";
import isString from "lodash/isString";
import vSelect from "vue-select";
const { mapGetters: mapGettersOfMapSetting } =
  createNamespacedHelpers("mapSetting");

// utils
import { WakeLineUtil } from "@/utils";
import {
  calcTaskVesselName,
  isSameTaskVesselNameAndMasterVesselName,
  createVesselOptions,
  createVesselOption,
} from "@/utils/gkmgPortMaster";
import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const voyageRecordsApi = AiseaApiFactory.get("voyageRecords");
const INPUT_MODE = {
  TEXT: "text",
  SELECT: "select",
};
const INITIAL_INPUT_STATE = {
  isEditVesselName: false, // 船舶名変更中かどうか(船舶マスタでなく、タスクの船舶名を変更)
  tmpVesselName: "", // 船舶名変更時の一時保存用
  inputMode: INPUT_MODE.SELECT,
  selectedVessel: null, // ドロップダウンから選択した船舶
};

export default {
  name: "DialogPortVessel",
  props: {
    showPopup: { type: Boolean, required: true },
    taskId: { type: String, required: true },
    columnKey: { type: String, required: true },
    valueMap: { required: true },
    canEdit: { type: Boolean, default: false },
    vesselsData: {
      type: Array, // vesselsData は船舶マスタのデータを想定
      default: () => [],
    },
  },
  components: {
    vSelect,
  },
  data() {
    return {
      initialized: false,
      vesselId: null, // pm_vesselsではなく、位置情報取得に対応した船舶のid
      vessel: null, // pm_vesselsではなく、位置情報取得に対応した船舶の情報
      wakes: [],
      //// mapbox
      map: null,
      accessToken: process.env.VUE_APP_MAPBOX_TOKEN,
      mapStyle: MAP_STYLE_DEFAULT + "?optimize=false",
      defaultPosition: { zoom: 13 },
      firestoreUnsubscribes: [],
      isFindVessel: null,
      timerId: null,
      loading: true,
      ...INITIAL_INPUT_STATE,
    };
  },
  watch: {
    async showPopup() {
      if (this.showPopup !== false) {
        if (!this.isSameTaskVesselNameAndMasterVesselName) return; //船舶名がマスタと異なる場合は地図を表示しない
        this.$nextTick(() => {
          this.onLoad();
        });
      } else {
        this.onUnload();
        this.$nextTick(() => {
          setTimeout(this.cancelEditVesselName, 200);
        });
      }
    },
    isEditVesselName() {
      this.inputMode = this.isSameTaskVesselNameAndMasterVesselName
        ? INPUT_MODE.SELECT
        : INPUT_MODE.TEXT;
      this.setInitialInputMode();
    },
    inputMode() {
      this.setInitialInputMode();
    },
  },
  computed: {
    ...mapState({
      destinationWorkTasksMap: (state) => state.destinationWorkTasksMap,
    }),
    ...mapGettersOfGkmgPortMasterDestinationWork({
      selectedDate: "selectedDate",
    }),
    ...mapGetters({
      vesselPositionCollection: "vesselPositionCollection",
    }),
    ...mapGettersOfMapSetting(["getCenter"]),
    ...mapGettersOfGkmgPortMaster({
      vesselsDataMap: "vesselsDataMap",
    }),
    center() {
      const lng = Number(this.getCenter.lng);
      const lat = Number(this.getCenter.lat);
      return [lng, lat];
    },
    taskData() {
      // 船舶マスタを取得するためにtaskを取得するが、taskのデータは表示しない
      return this.destinationWorkTasksMap[this.date][this.taskId];
    },
    vesselsMaster() {
      const DEFAULT_VESSEL_MASTER = { data: {} };
      const { taskData, vesselsDataMap } = this;
      if (!isObject(taskData)) return DEFAULT_VESSEL_MASTER;
      if (!isObject(taskData.vessel_id)) return DEFAULT_VESSEL_MASTER;
      const vesselId = taskData.vessel_id.valueMap.itSelf; // pm_vesselsのvessel_id
      return vesselsDataMap[vesselId];
    },
    date() {
      return this.selectedDate.replaceAll("/", "");
    },
    // taskに紐づく船舶名
    // 船舶マスタのものとは異なる可能性がある
    taskVesselName() {
      const { taskData } = this;
      return calcTaskVesselName(taskData);
    },

    isSameTaskVesselNameAndMasterVesselName() {
      const { taskData, vesselsMaster } = this;
      return isSameTaskVesselNameAndMasterVesselName(taskData, vesselsMaster);
    },

    isSameTempVesselNameAndMasterVesselName() {
      const { taskVesselName, trimmedTmpVesselName } = this;
      return taskVesselName === trimmedTmpVesselName;
    },

    isSameSelectedAndMasterVessel() {
      const { selectedVessel, vesselsMaster } = this;
      if (!isObject(selectedVessel)) return false;
      if (!(isObject(vesselsMaster) && isObject(vesselsMaster.data))) {
        return false;
      }
      return selectedVessel.id === vesselsMaster.data.id;
    },

    isSameTaskVesselNameAndSelectedVesselName() {
      const { taskVesselName, selectedVesselName } = this;
      return taskVesselName === selectedVesselName;
    },

    // データ更新時にtrimしたい
    trimmedTmpVesselName() {
      const { tmpVesselName } = this;
      if (!tmpVesselName) return "";
      return tmpVesselName.trim();
    },

    vesselOptions() {
      const { vesselsData } = this;
      return createVesselOptions(vesselsData);
    },

    selectedVesselName() {
      const { selectedVessel } = this;
      if (!isObject(selectedVessel)) return "";
      return selectedVessel.label || "";
    },

    isValidVesselName() {
      const { isTextMode, trimmedTmpVesselName } = this;
      if (!isTextMode) return true;
      if (!isString(trimmedTmpVesselName)) return false;
      if (trimmedTmpVesselName.length === 0) return false;
      return true;
    },

    isValidSelectedVessel() {
      const { isTextMode, selectedVessel } = this;
      if (isTextMode) return true;
      return (
        isObject(selectedVessel) &&
        isString(selectedVessel.id) &&
        isString(selectedVessel.label)
      );
    },

    isValidVesselInfo() {
      return this.isValidVesselName && this.isValidSelectedVessel;
    },

    isTextMode() {
      return this.inputMode === INPUT_MODE.TEXT;
    },
  },
  methods: {
    setInitialInputMode() {
      const {
        isTextMode,
        isSameTaskVesselNameAndMasterVesselName,
        vesselsMaster,
      } = this;
      if (isTextMode) {
        this.tmpVesselName = this.taskVesselName;
        this.$nextTick(() => {
          this.focusInput(); // 船舶名編集モードに移行したらフォーカスを当てる
        });
      } else {
        this.selectedVessel = isSameTaskVesselNameAndMasterVesselName
          ? createVesselOption(vesselsMaster)
          : null;
      }
    },
    moveToTextMode() {
      this.inputMode = INPUT_MODE.TEXT;
    },
    moveToSelectMode() {
      this.inputMode = INPUT_MODE.SELECT;
    },
    focusInput(
      selector = ".input-task-vessel-name input", // string(css selector)
    ) {
      const inputField = this.$el.querySelector(selector);
      if (inputField) {
        inputField.focus();
      }
    },
    onClickEditVesselName() {
      this.isEditVesselName = true;
    },

    cancelEditVesselName() {
      this.resetInputState();
    },

    onClickUpdateVessel() {
      const {
        isTextMode,
        isSameTempVesselNameAndMasterVesselName,
        isSameSelectedAndMasterVessel,
        isSameTaskVesselNameAndSelectedVesselName,
      } = this;
      // テキスト入力の場合、船舶名が変わらない場合は更新しない
      const shouldBeUpdatedTextMode =
        isTextMode && !isSameTempVesselNameAndMasterVesselName;
      // 選択式の場合、 以下の場合に更新する
      // 船舶id が変わる場合
      // 選択した船舶id の船舶名がタスクの船舶名と異なる
      const shouldBeUpdatedSelectMode =
        !isTextMode &&
        (!isSameSelectedAndMasterVessel ||
          !isSameTaskVesselNameAndSelectedVesselName);
      if (shouldBeUpdatedTextMode) {
        this.onSubmitVesselName();
      } else if (shouldBeUpdatedSelectMode) {
        this.onSubmitSelectedVessel();
      }
      this.$nextTick(() => {
        setTimeout(this.cancelEditVesselName, 200);
      });
    },

    onSubmitVesselName(isUpdateTimeStamp) {
      /*
       * onSubmit(false)    : 保存
       * onSubmit(true)     : ハイライト保存
       */
      if (!this.isValidVesselName) return;

      let mode = [];
      if (isUpdateTimeStamp) mode.push("updateTimeStamp");
      const updateKeyValueMap = {};
      updateKeyValueMap["vessel_name"] = this.trimmedTmpVesselName; // 船舶名を更新
      updateKeyValueMap["updated_at"] = new Date(
        moment().local().format("YYYY-MM-DD HH:mm:ss"),
      );
      this.$emit("updateValue", this.taskId, updateKeyValueMap, mode);
    },
    onSubmitSelectedVessel(isUpdateTimeStamp) {
      /*
       * onSubmit(false)    : 保存
       * onSubmit(true)     : ハイライト保存
       */
      if (!this.isValidSelectedVessel) return;

      let mode = [];
      if (isUpdateTimeStamp) mode.push("updateTimeStamp");
      const updateKeyValueMap = {};
      updateKeyValueMap["vessel_id"] = this.selectedVessel.id; // 船舶idを更新
      updateKeyValueMap["vessel_name"] = this.selectedVesselName; // 船舶名を更新
      updateKeyValueMap["updated_at"] = new Date(
        moment().local().format("YYYY-MM-DD HH:mm:ss"),
      );
      this.$emit("updateValue", this.taskId, updateKeyValueMap, mode);
    },
    resetInputState() {
      Object.keys(INITIAL_INPUT_STATE).forEach((key) => {
        this[key] = INITIAL_INPUT_STATE[key];
      });
    },
    ...mapActionsOfVesselView([
      "setVesselLivePosition",
      "crateLiveVesselsFeatureCollections",
      "fetchWakeLine",
      "crateWakeLineFeatureCollection",
    ]),
    ...mapActions(["getVessel"]),
    initMapbox() {
      Mapbox.accessToken = this.accessToken;
      this.map = new Mapbox.Map({
        container: "pm-vessel-live-map-container",
        style: this.mapStyle,
        center: this.center,
        zoom: this.defaultPosition.zoom,
      });
      this.map.setMaxZoom(18);

      let navZoom = new Mapbox.NavigationControl({
        showZoom: true,
        showCompass: false,
        visualizePitch: true,
      });
      this.map.addControl(navZoom);
      navZoom._container.parentNode.className = "mapboxgl-ctrl-nav-zoom";

      let scale = new Mapbox.ScaleControl({
        maxWidth: 80,
        unit: "imperial",
      });
      this.map.addControl(scale);
      scale.setUnit("metric");

      // Mapboxのライフサイクルイベントセット
      this.map.on("style.load", this.mapStyleLoad);
    },
    async drawVessels(vesselInfo) {
      if (!vesselInfo) return;
      let vesselName = this.vesselsMaster.data.name || "-";
      this.vessel.name_ja !== null ? this.vessel.name_ja : this.vessel.name;
      let payload = {
        vesselId: this.vesselId, // 航跡にvessel_id使用(pm_vesselsのvessel_idではない)
        position: {
          l: {
            _lat: vesselInfo.vesselLastPosition.data.latitude,
            _long: vesselInfo.vesselLastPosition.data.longitude,
          },
        },
        ais: {
          c: Number(this.vessel.vessel_category.id),
          cc: this.vessel.country_code.id,
          cs: this.vessel.call_sign,
          fd: "---", // コンソールエラー回避のために仮値を設定
          i: this.vessel.imo,
          l: "---", // コンソールエラー回避のために仮値を設定
          m: this.vessel.mmsi,
          n: this.vessel.name,
          n_j: this.vessel.name_ja,
          w: "---", // コンソールエラー回避のために仮値を設定
        },
      };
      let res = await this.crateLiveVesselsFeatureCollections(payload);
      if (!this.map) return;
      this.setSources(res);

      this.wakes = vesselInfo.vesselRecord.data.p.map((el) => {
        return {
          lat: el.lat,
          lon: el.lon,
          v: el.v,
          opacity: 0.9,
          color: WakeLineUtil.getVelocityColor(el.v),
          localDate: el.d,
          vesselName: vesselName,
        };
      });

      await this.setWakeLineSources();

      if (!this.initialized) {
        let coordinates = {
          center: [
            vesselInfo.vesselLastPosition.data.longitude,
            vesselInfo.vesselLastPosition.data.latitude,
          ],
        };
        this.map.jumpTo(coordinates);
        this.map.zoomTo(12);
        this.initialized = true;
      }
    },
    async mapStyleLoad(_a, _b) {
      this.unsubscribeFireStore();
      this.createPulsing(this.map);
      this.addSources();
      this.addLayers();
      await this.setLiveData();
      setTimeout(() => {
        this.$vs.loading.close(
          "#pm-vessel-live-map-container-area > .con-vs-loading",
        );
        this.loading = false;
      }, 2000);
    },

    addLayers() {
      this.map.addImage("pulsing", this.pulsing, { pixelRatio: 2 });
      this.map.addLayer({
        id: LiveVesselMapLayer.LiveVesselPulsingLayer.id,
        type: "symbol",
        source: LiveVesselMapSource.LiveVesselPulsingSource.id,
        maxzoom: 15,
        layout: {
          "icon-allow-overlap": true,
          "icon-ignore-placement": true,
          "icon-image": "pulsing",
        },
      });

      this.map.addLayer({
        id: LiveVesselMapLayer.LiveVesselWakeLineLayer.id,
        type: "line",
        source: LiveVesselMapSource.LiveVesselWakeLineSource.id,
        paint: {
          "line-color": ["get", "color"],
          "line-width": 2.0,
          "line-opacity": ["get", "opacity"],
          "line-dasharray": [1, 1],
        },
      });

      this.map.addLayer({
        id: LiveVesselMapLayer.LiveVesselWakeLineLayerForClickEvent.id,
        type: "line",
        source: LiveVesselMapSource.LiveVesselWakeLineSourceForClickEvent.id,
        paint: {
          "line-width": 20.0,
          "line-opacity": 0.0,
        },
      });

      this.map.addLayer({
        id: LiveVesselMapLayer.LiveVesselVectorLayer.id,
        type: "line",
        source: LiveVesselMapSource.LiveVesselVectorSource.id,
        minzoom: 8,
        maxzoom: 24,
        layout: {
          "line-join": "round",
          "line-cap": "round",
        },
        paint: {
          "line-color": "#DA514B",
          "line-width": 2.0,
          "line-opacity": {
            type: "identity",
            property: "o",
          },
        },
      });

      this.map.addLayer({
        id: LiveVesselMapLayer.LiveVesselPolygonLayer.id,
        type: "fill",
        source: LiveVesselMapSource.LiveVesselPolygonSource.id,
        minzoom: 14,
        maxzoom: 24,
        paint: {
          "fill-color": {
            type: "identity",
            property: "co",
          },
        },
      });

      this.map.addLayer({
        id: LiveVesselMapLayer.LiveVesselSymbolLayer.id,
        type: "symbol",
        source: LiveVesselMapSource.LiveVesselSymbolSource.id,
        minzoom: 1,
        maxzoom: 14,
        layout: {
          "icon-allow-overlap": true,
          "icon-ignore-placement": true,
          "icon-pitch-alignment": "map",
          "icon-rotation-alignment": "map",
          "icon-image": "{i}",
          "icon-rotate": {
            type: "identity",
            property: "r",
          },
        },
        paint: {
          "icon-opacity": {
            type: "identity",
            property: "o",
          },
        },
      });

      this.map.addLayer({
        id: LiveVesselMapLayer.LiveVesselSymbolWithoutSizeLayer.id,
        type: "symbol",
        source: LiveVesselMapSource.LiveVesselSymbolSource.id,
        minzoom: 14,
        filter: ["all", ["==", ["number", ["get", "is_size"]], 0]],
        layout: {
          "icon-allow-overlap": true,
          "icon-ignore-placement": true,
          "icon-pitch-alignment": "map",
          "icon-rotation-alignment": "map",
          "icon-image": "{i}",
          "icon-rotate": {
            type: "identity",
            property: "r",
          },
        },
        paint: {
          "icon-opacity": {
            type: "identity",
            property: "o",
          },
        },
      });

      this.map.addLayer({
        id: LiveVesselMapLayer.LiveVesselTextLayer.id,
        type: "symbol",
        source: LiveVesselMapSource.LiveVesselSymbolSource.id,
        layout: {
          "text-field": "{n}",
          "text-anchor": "top",
          "text-size": 14,
          "text-line-height": 1.2,
          "text-offset": [0, 1.1],
          "text-allow-overlap": true,
          "text-ignore-placement": true,
        },
        paint: {
          "text-color": "#54B1FC",
          "text-halo-color": "#000000",
          "text-halo-width": 1,
        },
      });
    },

    addSources() {
      this.map.addSource(LiveVesselMapSource.LiveVesselPulsingSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });

      this.map.addSource(LiveVesselMapSource.LiveVesselWakeLineSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });

      this.map.addSource(
        LiveVesselMapSource.LiveVesselWakeLineSourceForClickEvent.id,
        {
          type: "geojson",
          data: {
            type: "FeatureCollection",
            features: [],
          },
        },
      );

      this.map.addSource(LiveVesselMapSource.LiveVesselVectorSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });

      this.map.addSource(LiveVesselMapSource.LiveVesselPolygonSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });

      this.map.addSource(LiveVesselMapSource.LiveVesselWithoutSizeSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });

      this.map.addSource(LiveVesselMapSource.LiveVesselSymbolSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });
    },

    setSources(featureCollections) {
      if (!this.map) return;
      const pulsingSource = this.map.getSource(
        LiveVesselMapSource.LiveVesselPulsingSource.id,
      );
      if (pulsingSource != null) {
        pulsingSource.setData(featureCollections.symbolFeatureCollection);
      }

      const pointSource = this.map.getSource(
        LiveVesselMapSource.LiveVesselSymbolSource.id,
      );
      if (pointSource != null) {
        pointSource.setData(featureCollections.symbolFeatureCollection);
      }

      const polygonSource = this.map.getSource(
        LiveVesselMapSource.LiveVesselPolygonSource.id,
      );
      if (polygonSource != null) {
        polygonSource.setData(featureCollections.polygonFeatureCollection);
      }

      const vectorSource = this.map.getSource(
        LiveVesselMapSource.LiveVesselVectorSource.id,
      );
      if (vectorSource != null) {
        vectorSource.setData(featureCollections.polygonFeatureCollection);
      }
    },

    unsubscribeFireStore() {
      if (this.firestoreUnsubscribes.length !== 0) {
        this.firestoreUnsubscribes.forEach((unsubscribe) => unsubscribe());
        this.firestoreUnsubscribes = [];
      }
    },

    async setWakeLineSources() {
      if (!this.map) return;
      if (this.wakes.length >= 2) {
        let featureCollection = await this.crateWakeLineFeatureCollection(
          this.wakes,
        );
        const source = this.map.getSource(
          LiveVesselMapSource.LiveVesselWakeLineSource.id,
        );
        if (source != null) {
          source.setData(featureCollection);
        }
        const sourceForClickEvent = this.map.getSource(
          LiveVesselMapSource.LiveVesselWakeLineSourceForClickEvent.id,
        );
        if (sourceForClickEvent != null) {
          sourceForClickEvent.setData(featureCollection);
        }
      }
    },

    async setLiveData() {
      if (this.vesselId && this.vessel) {
        await this.getVesselPosition();
      }
    },

    async getVesselPosition() {
      const vesselLastPosition = await voyageRecordsApi.getLastPosition(
        this.vesselId,
      );

      const payload = {
        vesselId: this.vesselId,
      };
      const vesselRecord = await voyageRecordsApi.fetchWakeByVesselId(payload);

      const vesselInfo = {
        vesselLastPosition,
        vesselRecord,
      };
      if (vesselInfo.vesselLastPosition.status) {
        this.isFindVessel = true;
        this.drawVessels(vesselInfo);
      }
    },

    createPulsing(map) {
      let size = 100;
      this.pulsing = {
        width: size,
        height: size,
        data: new Uint8Array(size * size * 4),
        onAdd: function () {
          let canvas = document.createElement("canvas");
          canvas.width = this.width;
          canvas.height = this.height;
          this.context = canvas.getContext("2d");
        },

        render: function () {
          let duration = 2000;
          let t = (performance.now() % duration) / duration;

          let radius = (size / 2) * 0.3;
          let outerRadius = (size / 2) * 0.7 * t + radius;
          let context = this.context;

          context.clearRect(0, 0, this.width, this.height);
          context.beginPath();
          context.arc(
            this.width / 2,
            this.height / 2,
            outerRadius,
            0,
            Math.PI * 2,
          );
          context.fillStyle = "rgba(255, 255, 255," + (1 - t) + ")";
          context.fill();

          this.data = context.getImageData(0, 0, this.width, this.height).data;

          map.triggerRepaint();

          return true;
        },
      };
    },

    formattedTime(dateValue) {
      if (!dateValue || !dateValue.value) {
        return "";
      }
      return moment(dateValue.value).local().format("HH:mm");
    },
    formattedTimeForProgress(dateValue) {
      if (
        !dateValue ||
        !dateValue.value ||
        !dateValue.progress ||
        !dateValue.value[dateValue.progress]
      ) {
        return "";
      }
      return moment(dateValue.value[dateValue.progress].seconds * 1000)
        .local()
        .format("HH:mm");
    },
    formattedVesselPositionLastUpdated(t) {
      return moment(t).format("YYYY-MM-DD-HH:mm:ss");
    },
    async onLoad() {
      this.loading = true;
      this.isFindVessel = false;
      this.$vs.loading({
        container: "#pm-vessel-live-map-container-area",
        scale: 0.6,
      });

      this.initialized = false;
      /*
       * gkmg_pm_vesselsから船舶IDを取得
       */

      const vesselId = Object.hasOwn(this.vesselsMaster.data, "aisea_vessel_id")
        ? this.vesselsMaster.data.aisea_vessel_id
        : null;
      const vessel = await this.getVessel({ vesselId });

      const isVessel =
        !(vessel instanceof Error) &&
        isObject(vessel) &&
        Object.hasOwn(vessel, "id");
      this.vesselId = isVessel ? String(vessel.id) : null;
      this.vessel = isVessel ? vessel : null;

      this.$nextTick(() => {
        this.initMapbox();
      });
    },
    onUnload() {
      this.wakes = [];
      this.unsubscribeFireStore();
      if (this.unSubscribeStore) {
        this.unSubscribeStore();
      }
      if (this.timerId) {
        clearTimeout(this.timerId);
        this.timerId = null;
      }
      this.setVesselLivePosition(null);

      this.map = null;

      let oldChildElement = document.getElementById(
        "pm-vessel-live-map-container",
      );

      if (oldChildElement) {
        //親要素内の子要素を削除
        oldChildElement.innerHTML = "";
      }
    },
  },
  async mounted() {
    if (!this.isSameTaskVesselNameAndMasterVesselName) return; //船舶名がマスタと異なる場合は地図を表示しない
    this.onLoad();
  },
  beforeDestroy() {
    this.onUnload();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/port-master/_variables.scss";
.th {
  min-width: 4rem;
  font-size: 90%;
  font-weight: bold;
  margin-left: 0.2rem;
  margin-right: 0.5rem;
}
.td {
  width: 100%;
  font-size: 120%;
  display: flex;
  align-items: center;
}
.pm-port-vessel-detail {
  height: 2.4rem;
}

#pm-vessel-live-map-container {
  width: 100%;
  height: 20rem;
  html,
  body {
    overflow: hidden;
  }

  .mapboxgl-ctrl-nav-zoom {
    top: 10px;
    left: calc(100% - 40px);
    position: absolute;
    pointer-events: none;
    z-index: 2;
  }
}

.vessel-name-area {
  width: 100%;
  max-width: 600px;
  // 船舶名編集
  ::v-deep .input-task-vessel-name {
    flex-grow: 1;
    flex-shrink: 0;
    > .vs-con-input {
      .vs-inputx {
        height: 35px;
      }
    }
    .con-text-validation {
      display: none; // バリデーション時のスタイル調整
    }
  }
  .edit-vessel-name {
    &:enabled {
      cursor: pointer;
    }
  }

  .select-input-mode {
    color: white;
    background-color: rgb(219, 219, 219);

    padding: 5px;
    border-radius: 5px;
    &:enabled {
      cursor: pointer;
    }

    &.selected-mode {
      pointer-events: none;
      background-color: rgb(46, 135, 185);
    }
    &:hover {
      background-color: rgb(46, 135, 185);
    }
  }
  .display-items-select-box {
    width: 200px;
    font-size: 14px;
    flex-shrink: 0;
  }
}
</style>

<style lang="scss">
// TODO: scoped あると親コンポーネントにスタイル適用できなかったため、やむを得ず scoped なしのスタイルを定義した
div.vs-popup--content {
  &:has(.gkmg-pm-dialog-port-vessel) {
    overflow: visible; // 船舶ドロップダウンリストをポップアップからはみ出ても表示するため
  }
}
</style>
